import {Injectable} from "@angular/core";
import {NavigationStart, Router} from "@angular/router";
import {Observable} from "rxjs";
import {Subject} from "rxjs/Subject";

@Injectable()
export class AlertService {
	private subject = new Subject<any>();
	private keepAfterNavigationChange = false;
	private defaultErrorMessage: string = 'ไม่สามารถทํารายการได้ในขณะนี้ กรุณาลองใหม่อีกครั้ง';

	constructor(private _router: Router) {
		// clear alert message on route change
		_router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				if (this.keepAfterNavigationChange) {
					// only keep for a single location change
					this.keepAfterNavigationChange = false;
				} else {
					// clear alert
					this.subject.next();
				}
			}
		});
	}

	success(message: string, keepAfterNavigationChange = false) {
		this.keepAfterNavigationChange = keepAfterNavigationChange;
		this.subject.next({type: 'success', text: message});
	}

	error(message: string, keepAfterNavigationChange = false) {
		this.keepAfterNavigationChange = keepAfterNavigationChange;
		this.subject.next({type: 'danger', text: (typeof message === 'string') ? message : this.defaultErrorMessage});
	}

  clear() {
    this.subject.next();
  }

	getMessage(): Observable<any> {
		return this.subject.asObservable();
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/authentication/_services/alert.service.ts